import { render, staticRenderFns } from "./SummaryCrPresence.vue?vue&type=template&id=084fbce2&scoped=true"
import script from "./SummaryCrPresence.vue?vue&type=script&lang=js"
export * from "./SummaryCrPresence.vue?vue&type=script&lang=js"
import style0 from "./SummaryCrPresence.vue?vue&type=style&index=0&id=084fbce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084fbce2",
  null
  
)

export default component.exports